// Public profiles (HotUtilsV2-Public) — the platform's LOGIN-FREE surface: players.hotutils.com and
// guilds.hotutils.com. Design: HotUtilsV2/docs/design/public-profiles.md §5.
//
// ⚠️ UNLIKE every other V2 embed util in this folder, there is NO token and NO postMessage handshake here —
// the public app has no viewer identity by design. The iframe src IS the shareable public URL, kept
// identical on purpose: a profile reached via the tab is the same URL someone pastes to a guildmate.

// The public players host, per environment. Override with REACT_APP_V2PUBLIC_PLAYERS_URL.
export function getV2PublicPlayersUrl(): string {
  const override = process.env.REACT_APP_V2PUBLIC_PLAYERS_URL;
  if (override) return override;
  return `https://${publicHostPrefix()}players.hotutils.com`;
}

// The public guilds host. Override with REACT_APP_V2PUBLIC_GUILDS_URL.
export function getV2PublicGuildsUrl(): string {
  const override = process.env.REACT_APP_V2PUBLIC_GUILDS_URL;
  if (override) return override;
  return `https://${publicHostPrefix()}guilds.hotutils.com`;
}

function publicHostPrefix(): string {
  const host = window.location.host;
  // players./guilds. are the PLANNED prod hostnames (design §3a) — prod is not stood up yet, and the tab
  // is gated off outside development by isV2PublicEnabled() anyway, so only the dev- pair is live today.
  if (host === 'hotutils.com' || host === 'www.hotutils.com' || host.startsWith('staging')) return '';
  return 'dev-';
}

/**
 * The V2-Players / V2-Guilds tabs are DEV-ONLY for now — surfaced only on the Development site and in
 * local dev, same gating rule as the other V2 embeds. The ROUTE and the MENU ITEM must be gated by this
 * same function, or the tab appears where it cannot work.
 */
export function isV2PublicEnabled(): boolean {
  const host = window.location.host;
  return host === 'development.hotutils.com' || host.startsWith('localhost');
}
